import React from "react";
import Image from "next/image";
import { homePageCommunityLink, homePageProductList } from "../../HomePage/constants";
import styles from "./styles.module.scss";

interface FooterProps {
  onDownloadClick: () => void;
}

/**
 * Footer组件 - 网站底部导航栏，包含Logo、联系信息、社区链接和产品导航
 */
const Footer: React.FC<FooterProps> = ({ onDownloadClick }) => {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          {/* Logo和联系信息 */}
          <div className={styles.logoSection}>
            <div className={styles.logoContainer}>
              <Image
                src="/logo.svg"
                alt="Fellou"
                width={126}
                height={56}
                className={styles.logo}
              />
            </div>
            <div className={styles.contactText}>Contact Us | hi@fellou.ai</div>
            <div className={styles.communityLinks}>
              {homePageCommunityLink.map((item, index) => (
                <a
                  key={index}
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.communityLink}
                >
                  <i className={item.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* 页脚链接 */}
          <div className={styles.linksContainer}>
            <div className={styles.linkColumn}>
              <h4 className={styles.columnTitle}>Product</h4>
              <div className={styles.linkList}>
                {homePageProductList[0].map((item, index) => {
                  // 特殊处理Download链接
                  if (item.title === "Download") {
                    return (
                      <button
                        key={index}
                        onClick={onDownloadClick}
                        className={styles.linkItem}
                      >
                        {item.title}
                      </button>
                    );
                  }

                  return (
                    <a
                      key={index}
                      href={item.path}
                      target={item.toway === 0 ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                      className={styles.linkItem}
                    >
                      {item.title}
                    </a>
                  );
                })}
              </div>
            </div>

            <div className={styles.linkColumn}>
              <h4 className={styles.columnTitle}>Framework</h4>
              <div className={styles.linkList}>
                {homePageProductList[1].map((item, index) => (
                  <a
                    key={index}
                    href={item.path}
                    target={item.toway === 0 ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className={styles.linkItem}
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </div>

            <div className={styles.linkColumn}>
              <h4 className={styles.columnTitle}>Company</h4>
              <div className={styles.linkList}>
                {homePageProductList[2].map((item, index) => (
                  <a
                    key={index}
                    href={item.path}
                    target={item.toway === 0 ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className={styles.linkItem}
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </div>

            <div className={styles.linkColumn}>
              <h4 className={styles.columnTitle}>Legal</h4>
              <div className={styles.linkList}>
                {homePageProductList[3].map((item, index) => (
                  <a
                    key={index}
                    href={item.path}
                    target={item.toway === 0 ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className={styles.linkItem}
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
